var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"vueWaterfall",staticClass:"vue-waterfall",class:_vm.isTransition && 'is-transition',style:({ height: _vm.height }),attrs:{"id":"vueWaterfall"}},[_c('div',{staticClass:"slot-box"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }